import React from 'react';
import { Link } from 'react-router-dom';
import { Form, Row, Col, Nav } from 'react-bootstrap';

import Select from 'react-select';
import ExpandingTextArea from 'react-expanding-textarea';

// Services & Helpers
import GlobalStateService from 'services/GlobalStateService';
import BaseService from 'services/BaseService';
import CurrencyService from 'services/CurrencyService';
import BootboxHelper from 'helpers/BootboxHelper';

// Components
import Loader from 'components/common/Loader';
import CourseTier from 'components/common/CourseTier';

//-------------------------------------------------------------------------------------------------------------------

class Contract extends React.Component {

    constructor(props) {
        super(props);

        this.updateFields = this.updateFields.bind(this);

        this.state = {
            isLoading: true,
            //geoID: props.instructor?.primaryGeoID
        };
    }

    componentDidMount() {
        this.load();
    }

    async load() {
        const instructor = await BaseService.callAPI('instructor/get-contract-details/' + this.props.instructor.id);
        const currencies = await CurrencyService.list();
        let subAgency;
        if (instructor.subAgencySlug) {
            subAgency = await BaseService.callAPI('sub-agency/get-basic-details/' + instructor.subAgencySlug);
        }
        this.setState({
            instructor,
            currencies,
            subAgency,
            isLoading: false
        });
    }

    async save() {
        const { setIsBusy, setIsChanged } = this.props;
        const { instructor } = this.state;
        setIsBusy(true);
        this.setState({ isLoading: true });
        await BaseService.callAPI('instructor/save-contract-details', instructor);
        setIsBusy(false);
        setIsChanged(false);
        this.setState({ isLoading: false });
        BootboxHelper.alert('Changes saved');
    }

    updateFields(values) {
        const instructor = { ...this.state.instructor };
        for (var fieldName in values) {
            const value = values[fieldName];
            instructor[fieldName] = value;

            switch (fieldName) {
                case 'bankCountryID':
                    instructor.bankCountry = this.props.countries.find(c => c.id == instructor.bankCountryID);
                    break;
            }
        }
        this.setState({ instructor });
        this.props.setIsChanged(true, () => this.save());
    }

    updateRateCardFields(values) {
        const { geoID } = this.state;
        const rateCards = [...this.state.instructor.rateCards];
        let index = rateCards.findIndex(rc => rc.geoID == geoID);
        if (index == -1) {
            index = rateCards.length;
            rateCards.push({ geoID });
        }
        const rateCard = { ...rateCards[index] };
        for (var fieldName in values) {
            const value = values[fieldName];
            rateCard[fieldName] = value;
        }
        rateCards[index] = rateCard;
        this.updateFields({ rateCards });
    }

    addCourseRate(courseID) {
        const { geoID, instructor } = this.state;
        const courseRates = [...this.state.instructor.courseRates];
        const course = { ...instructor.courses.find(c => c.courseID == courseID).course };
        courseRates.push({
            geoID,
            courseID,
            rate: null,
            course
        });
        this.updateFields({ courseRates });
    }

    updateCourseRate(courseID, rate) {
        const { geoID } = this.state;
        const courseRates = [...this.state.instructor.courseRates];
        const index = courseRates.findIndex(icr => icr.courseID == courseID && icr.geoID == geoID);
        const courseRate = { ...courseRates[index] };
        courseRate.rate = rate;
        courseRates[index] = courseRate;
        this.updateFields({ courseRates });
    }

    async confirmRemoveCourseRate(courseID) {
        const { geoID } = this.state; 
        const confirm = await BootboxHelper.confirm('Remove this course-specific rate?');
        if (confirm) {
            const courseRates = [...this.state.instructor.courseRates];
            const index = courseRates.findIndex(icr => icr.courseID == courseID && icr.geoID == geoID);
            courseRates.splice(index, 1);
            this.updateFields({ courseRates });
        }
    }

    //-------------------------------------------------------------------------------------------------------------------
    //  Render
    //-------------------------------------------------------------------------------------------------------------------

    render() {
        const { isLoading } = this.state;

        if (isLoading) {
            return (<Loader fullPage />);
        }

        return (<>

            {this.renderRateCards()}
            {this.renderFinancials()}

        </>);
    }

    renderRateCards() {
        const { isEditMode } = this.props;
        const { instructor, currencies, geoID } = this.state;
        const rateCard = instructor.rateCards.find(rc => rc.geoID == geoID) || { geoID };
        const loginInfo = GlobalStateService.getValue('loginInfo');
        const defaultPaymentTerms = loginInfo.site.defaultPaymentTerms;
        //const geos = this.props.geos.filter(g => instructor.geoIDs[g.id]);

        return (<>

            <h2>Contract</h2>

            <Row>

                <Col md="4">

                    <Form.Group className="mb-3">
                        <Form.Label>Contract type</Form.Label>
                        <select
                            className="form-control"
                            value={instructor.contractType || ''}
                            onChange={e => this.updateFields({ contractType: e.target.value })}
                        >
                            <option value="">(Please select)</option>
                            <option value="StatusOnly">Contract 1 - Status only</option>    
                            <option value="TierOnly">Contract 2 - Tier only</option>    
                            <option value="StatusAndTier">Contract 3 - Status & tier</option>    
                            <option value="FlatRate">Contract 4 - Flat rate</option>
                        </select>
                    </Form.Group>

                </Col>

                <Col md="4">

                    <Form.Group className="mb-3">
                        <Form.Label>Currency</Form.Label>
                        <Select
                            className="react-select-container"
                            classNamePrefix="react-select"
                            value={instructor.currencyID ? currencies.find(c => c.id == instructor.currencyID) : null}
                            options={currencies}
                            getOptionValue={c => c.id}
                            getOptionLabel={c => `${c.name} (${c.code})`}
                            onChange={v => this.updateFields({ currencyID: v.id })}
                            isDisabled={!isEditMode}
                        />
                    </Form.Group>

                </Col>

                <Col md="4">

                    <Form.Group className="mb-3">
                        <Form.Label>Payment type</Form.Label>
                        <select
                            className="form-control"
                            value={instructor.paymentType || ''}
                            onChange={e => this.updateFields({ paymentType: e.target.value })}
                        >
                            <option value="">(Please select)</option>
                            <option value="Euro">Euro</option>
                            <option value="International">International</option>
                            <option value="Faster">Faster</option>
                            <option value="BACS">BACS</option>
                            <option value="USD">USD</option>
                        </select>
                    </Form.Group>

                </Col>

            </Row>

            <h2>Rate card</h2>

            {/*
            {geos.length > 1 &&
                <Nav variant="pills" className="mb-4">
                    {geos.map(g =>
                        <Nav.Item key={g.id}>
                            <Link
                                className={'nav-link ' + (g.id == geoID ? 'active' : '')}
                                to="#"
                                onClick={e => { this.setState({ geoID: g.id }); e.preventDefault() }}
                            >
                                {g.name}
                            </Link>
                        </Nav.Item>
                    )}
                </Nav>
            }
            */}

            <Row>

                <Col md="6">

                    <Form.Group className="mb-3">
                        <Form.Label>Rate 1</Form.Label>
                        {isEditMode ?
                            <input
                                className="form-control"
                                type="number"
                                value={rateCard.costRate1 || ''}
                                onChange={e => this.updateRateCardFields({ costRate1: e.target.value })}
                            /> :
                            <p>{rateCard.costRate1}</p>
                        }
                    </Form.Group>

                </Col>

                <Col md="6">

                    {instructor.contractType != 'FlatRate' &&
                        <Form.Group className="mb-3">
                            <Form.Label>Rate 2</Form.Label>
                            {isEditMode ?
                                <input
                                    className="form-control"
                                    type="number"
                                    value={rateCard.costRate2 || ''}
                                    onChange={e => this.updateRateCardFields({ costRate2: e.target.value })}
                                /> :
                                <p>{rateCard.costRate2}</p>
                            }
                        </Form.Group>
                    }

                </Col>

            </Row>

            <Row>

                <Col md="6">

                    <Form.Group className="mb-3">
                        <Form.Label>Other rate details (max 3 lines)</Form.Label>
                        {isEditMode ?
                            <ExpandingTextArea
                                className="form-control"
                                value={rateCard.otherRateDetails || ''}
                                onChange={e => this.updateRateCardFields({ otherRateDetails: e.target.value })}
                            /> :
                            <p>{rateCard.otherRateDetails}</p>
                        }
                    </Form.Group>

                </Col>

                <Col md="6">

                    <Form.Group className="mb-3">
                        <Form.Label>Override default payment terms for new contracts</Form.Label>
                        {isEditMode ?
                            <div className="input-group">
                                <input
                                    className="form-control"
                                    type="number"
                                    value={rateCard.overridePaymentTerms || ''}
                                    onChange={e => this.updateRateCardFields({ overridePaymentTerms: e.target.value })}
                                    placeholder={defaultPaymentTerms[instructor.primaryGeoID]}
                                />
                                <div className="input-group-append">
                                    <span className="input-group-text">Days</span>
                                </div>
                            </div> :
                            <p>{rateCard.overridePaymentTerms} {rateCard.overridePaymentTerms > 0 ? ' days' : ''}</p>
                        }
                    </Form.Group>


                </Col>

            </Row>

            <Row>

                <Col md="6">

                    {this.renderSpecificCourseRates()}

                </Col>

            </Row>

        </>);
    }

    renderSpecificCourseRates() {
        const { instructor, geoID } = this.state;
        const courseRates = instructor.courseRates.filter(cr => cr.geoID == geoID);
        
        return (
            <Form.Group className="">
                <Form.Label>Course-specific rates</Form.Label>
                <div className="sticky-table-container no-max-height-desktop">
                    <table className="table table-bordered sticky-table course-specific-rates-table">
                        <thead>
                            <tr>
                                <th className="course-column">Course</th>
                                <th className="rate-column">Rate</th>
                                <th className="actions-column"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {courseRates.map(icr => {
                                return (
                                    <tr key={icr.courseID}>
                                        <td className="course-column">
                                            {icr.course.name}
                                            <CourseTier tier={icr.course.tier} />
                                        </td>
                                        <td className="rate-column">
                                            <input
                                                className="form-control"
                                                type="number"
                                                value={icr.rate || ''}
                                                onChange={e => this.updateCourseRate(icr.courseID, e.target.value)}
                                            />
                                        </td>
                                        <td className="actions-column">
                                            <button type="button" className="btn btn-danger" onClick={() => this.confirmRemoveCourseRate(icr.courseID)}>
                                                <span className="fa fa-times" />
                                            </button>
                                        </td>
                                    </tr>
                                );
                            })}
                            <tr>
                                <td>
                                    <Select
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        isClearable={false}
                                        options={instructor.courses
                                            .filter(ic => !instructor.courseRates.find(icr => icr.courseID == ic.course.id && icr.geoID == geoID))
                                            .map(ic => ic.course)
                                        }
                                        getOptionValue={c => c.id}
                                        getOptionLabel={c => `${c.name} (${c.tier})`}
                                        onChange={c => this.addCourseRate(c.id)}
                                        value={null}
                                    />
                                </td>
                                <td></td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </Form.Group>
        );
    }

    renderFinancials() {
        const { isEditMode } = this.props;
        const { instructor, subAgency } = this.state;

        return (<>

            <h2>Financial details</h2>

            {subAgency ? <>

                <Row>

                    <Col md="6">

                        <Form.Group className="mb-3">
                            <Form.Label>Sub-agency</Form.Label>
                            <p className="form-control-plaintext">
                                {subAgency.name}{' '}
                                <Link to={`/sub-agency/${subAgency.slug}`} className="btn btn-secondary">
                                    <span className="fa fa-search" />
                                </Link>
                            </p>
                        </Form.Group>

                    </Col>

                    <Col md="6">

                        <Form.Group className="mb-3">
                            <Form.Label>Home address</Form.Label>
                            {isEditMode ?
                                <ExpandingTextArea
                                    className="form-control"
                                    value={instructor.address || ''}
                                    onChange={e => this.updateFields({ address: e.target.value })}
                                    rows={4}
                                /> :
                                <p className="pre">{instructor.address || '—'}</p>
                            }
                        </Form.Group>

                    </Col>

                </Row>

                {this.renderFinancialsInner(subAgency || {}, false, 'Company address', () => null)}

            </> : <>

                {this.renderFinancialsInner(instructor, isEditMode, 'Home address', this.updateFields)}

            </>}
            
        </>);
    }
    
    renderFinancialsInner(obj, isEditMode, addressLabel, fnUpdateFields) {
        const { countries } = this.props;

        return (<>
            
            <Row>

                <Col md="6">

                    <Form.Group className="mb-3">
                        <Form.Label>Name on bank account</Form.Label>
                        {isEditMode ?
                            <input
                                className="form-control"
                                type="text"
                                value={obj.nameOnBankAccount || ''}
                                onChange={e => fnUpdateFields({ nameOnBankAccount: e.target.value })}
                            /> :
                            <p>{obj.nameOnBankAccount || '—'}</p>
                        }
                    </Form.Group>

                </Col>

                <Col md="6">

                    <Form.Group className="mb-3">
                        <Form.Label>Company name</Form.Label>
                        {isEditMode ?
                            <input
                                className="form-control"
                                type="text"
                                value={obj.companyName || ''}
                                onChange={e => fnUpdateFields({ companyName: e.target.value })}
                            /> :
                            <p>{obj.companyName || '—'}</p>
                        }
                    </Form.Group>

                </Col>

            </Row>

            <Row>

                <Col md="6">

                    <Form.Group className="mb-3">
                        <Form.Label>Bank address</Form.Label>
                        {isEditMode ?
                            <ExpandingTextArea
                                className="form-control"
                                value={obj.bankAddress || ''}
                                onChange={e => fnUpdateFields({ bankAddress: e.target.value })}
                                rows={4}
                            /> :
                            <p className="pre">{obj.bankAddress || '—'}</p>
                        }
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Bank country</Form.Label>
                        {isEditMode ?
                            <Select
                                className="react-select-container"
                                classNamePrefix="react-select"
                                isClearable={false}
                                options={countries}
                                value={obj.bankCountry}
                                getOptionValue={c => c.id}
                                getOptionLabel={c => c.name}
                                onChange={country => fnUpdateFields({ bankCountryID: country.id })}
                            /> :
                            <p className="pre">{obj.bankCountry ? obj.bankCountry.name : '—'}</p>
                        }
                    </Form.Group>

                </Col>

                <Col md="6">

                    <Form.Group className="mb-3">
                        <Form.Label>{addressLabel}</Form.Label>
                        {isEditMode ?
                            <ExpandingTextArea
                                className="form-control"
                                value={obj.address || ''}
                                onChange={e => fnUpdateFields({ address: e.target.value })}
                                rows={4}
                            /> :
                            <p className="pre">{obj.address || '—'}</p>
                        }
                    </Form.Group>

                </Col>

            </Row>

            <Row>

                <Col md="6">

                    <Form.Group className="mb-3">
                        <Form.Label>IBAN</Form.Label>
                        {isEditMode ?
                            <input
                                className="form-control"
                                type="text"
                                value={obj.iban || ''}
                                onChange={e => fnUpdateFields({ iban: e.target.value })}
                            /> :
                            <p>{obj.iban || '—'}</p>
                        }
                    </Form.Group>

                </Col>

                <Col md="6">

                    <Form.Group className="mb-3">
                        <Form.Label>SWIFT / BIC</Form.Label>
                        {isEditMode ?
                            <input
                                className="form-control"
                                type="text"
                                value={obj.swiftbic || ''}
                                onChange={e => fnUpdateFields({ swiftbic: e.target.value })}
                            /> :
                            <p>{obj.swiftbic || '—'}</p>
                        }
                    </Form.Group>

                </Col>

            </Row>

            <Row>

                <Col md="6">

                    <Form.Group>
                        <Form.Label>Sort code</Form.Label>
                        {isEditMode ?
                            <input
                                className="form-control"
                                type="text"
                                value={obj.sortCode || ''}
                                onChange={e => fnUpdateFields({ sortCode: e.target.value })}
                            /> :
                            <p>{obj.sortCode || '—'}</p>
                        }
                    </Form.Group>

                </Col>

                <Col md="6">

                    <Form.Group>
                        <Form.Label>Account number</Form.Label>
                        {isEditMode ?
                            <input
                                className="form-control"
                                type="text"
                                value={obj.accountNumber || ''}
                                onChange={e => fnUpdateFields({ accountNumber: e.target.value })}
                            /> :
                            <p>{obj.accountNumber || '—'}</p>
                        }
                    </Form.Group>

                </Col>

            </Row>

        </>);
    }

}

export default Contract;